import { TextField } from '@mui/material'
import { type ControllerProps } from 'react-hook-form'

import { type StatusCheckFormValues } from 'components/status-checks/status-checks-form-utils'

export const StatusCheckNameFieldInput: ControllerProps<
  StatusCheckFormValues,
  'statusCheckName'
>['render'] = ({ field, fieldState }) => {
  const { error } = fieldState

  return (
    <TextField
      {...field}
      required
      data-testid="status-check-monitor-name-input"
      error={Boolean(error)}
      helperText={error?.message}
      label="Health Check Name"
    />
  )
}
